import React, { useState, useEffect } from 'react'
import {
  Table,
  IconButton,
  Icon,
  Panel,
  Row,
  Col,
  SelectPicker,
  Input,
  Dropdown,
  Button,
  Whisper,
  Popover,
  ButtonToolbar,
} from 'rsuite'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { DD_MM_YYYY_SLASH } from '../../constants/date'
import { budgetFormat } from '../../utils/formatterUtil'
import moment from 'moment'
import { sessionGetItemObj } from '../../utils/sessionHelpers'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'
import { doneLoading, startLoading } from '../../utils/loading'
import { downloadExpenseRecordVoucherFile } from '../../redux/actions/accountingExpenseRequest'
import { previewFile } from '../../utils/fileUtil'
import notification from '../../utils/notification'
import {
  downloadBorrowAdvanceContractForm,
  downloadBorrowAdvanceRecieptVoucher,
  downloadBorrowAdvanceRetrunForm,
  downloadBorrowAdvanceVoucher,
} from '../../redux/actions/paymentRecordAdvance'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import '../../widgets/projectBasedItemsWidget/styles_table.less'

export default function BorrowAvanceVoucherListTable({
  schema,
  pagination,
  loading,
  onSelect,
  onSearch,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table

  const [tableData, setTableData] = useState([])

  const [borrowType, setBorrowType] = useState('0') // 0 = ทั้งหมด , 1 = ยืมเงิน , 2 = คืนเงิน
  const [voucherNumber, setVoucherNumber] = useState()
  const [borrower, setBorrower] = useState()
  const [borrowDesc, setBorrowDesc] = useState()
  const [borrowStartDate, setBorrowStartDate] = useState()
  const [borrowEndDate, setBorrowEndDate] = useState()
  const [returnStartDate, setReturnStartDate] = useState()
  const [returnEndDate, setReturnEndDate] = useState()
  const [isLoading, setIsLoading] = useState()
  //const { periodNumber, startAndEndDate } = sessionGetItemObj('periodInfo')

  const fs = localStorage.getItem('fontSize')
  const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }
  const manageButtonStyle = { width: '100%', marginTop: 10 }

  useEffect(() => {
    setTableData(schema.datas.values || [])
  }, [schema])

  const createRequest = () => {
    return {
      borrowType: borrowType,
      voucherNumber: voucherNumber,
      borrower: borrower,
      borrowDesc: borrowDesc,
      borrowStartDate: borrowStartDate ? moment(borrowStartDate).format(DD_MM_YYYY_SLASH) : '',
      borrowEndDate: borrowEndDate ? moment(borrowEndDate).format(DD_MM_YYYY_SLASH) : '',
      returnStartDate: returnStartDate ? moment(returnStartDate).format(DD_MM_YYYY_SLASH) : '',
      returnEndDate: returnEndDate ? moment(returnEndDate).format(DD_MM_YYYY_SLASH) : '',
    }
  }

  const handleSearch = () => {
    // console.log('handleSearch ')
    const request = createRequest()

    onSearch(request)
  }

  const handleCancel = () => {
    setBorrowType(0)
    setVoucherNumber('')
    setBorrower('')
    setBorrowStartDate(null)
    setBorrowEndDate(null)
    setReturnStartDate(null)
    setReturnEndDate(null)

    onSearch({})
  }

  const handleGetExpenseVoucher = async (accountingExpenseId) => {
    setIsLoading(true)
    startLoading()
    try {
      //var files = filePath?.split('/')
      var file = await downloadExpenseRecordVoucherFile(accountingExpenseId)

      previewFile(file, accountingExpenseId + '.pdf')
    } catch (e) {
      // console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetBorrowVoucher = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      var file = await downloadBorrowAdvanceVoucher(id)

      previewFile(file, id + '.pdf')
    } catch (e) {
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetBorrowRecieptVoucher = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      var file = await downloadBorrowAdvanceRecieptVoucher(id)

      previewFile(file, id + '.pdf')
    } catch (e) {
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetBorrowContratForm = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      var file = await downloadBorrowAdvanceContractForm(id)

      previewFile(file, id + '.pdf')
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetBorrowRetrunForm = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      var file = await downloadBorrowAdvanceRetrunForm(id)

      previewFile(file, id + '.pdf')
    } catch (e) {
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const TagCell = ({ rowData, dataKey, ...props }) => {
    let bgColor = '#f2f1f1' //สีเทา
    let _color = '#313131' // สีดำ

    switch (rowData.borrowStatus) {
      // ยังไม่คืนเงินทดรองจ่าย
      case 1:
        if (rowData.overEstimateReturnDate > 0) {
          bgColor = '#fb8a81' //สีแดง
          _color = '#ffffff'
        } else {
          bgColor = '#f2f1f1' //สีเทา
          _color = '#313131'
        }
        break

      // คืนเงินทดรองจ่ายแล้ว
      case 2:
        bgColor = '#2da888' //สีเขียว
        _color = '#ffffff'
        break

      // ยกเลิกเงินทดรองจ่าย
      case 3:
        bgColor = '#fa8900' //สีส้ม
        _color = '#ffffff'
        break

      // คืนเงินทดรองจ่ายแล้ว (ร่าง)
      case 4:
        bgColor = '#a0c26c' //สีเขียว
        _color = '#ffffff'
        break

      default:
        break
    }

    return (
      <Cell {...props}>
        <div
          className="tag"
          style={{
            backgroundColor: bgColor,
          }}
        >
          <span className="tag__text" style={{ color: _color }}>
            {rowData.borrowStatusName || ''}
          </span>
        </div>
      </Cell>
    )
  }

  const MenuPopover = ({ onSelected, rowData, ...rest }) => {
    return (
      <Popover {...rest} full>
        <div
          style={{
            borderStyle: 'solid',
            borderWidth: 3,
            padding: 5,
            borderColor: '#2DA885',
            borderRadius: 5,
            width: 200,
          }}
        >
          {rowData.borrowStatus != 3 && [2, 4].includes(rowData.borrowStatus) && (
            <IconButton
              appearance="ghost"
              className={`rs-btn-ghost-df`}
              size="sm"
              style={{ width: '100%', marginBottom: 8 }}
              icon={<Icon icon={`eye`} className={'bt-gost-icon-none-radius'} />}
              onClick={(e) => {
                onSelect(rowData, '1')
              }}
            >
              แสดงเงินยืม
            </IconButton>
          )}

          {[2, 4].includes(rowData.borrowStatus) ? (
            <>
              <IconButton
                appearance="ghost"
                className={schema.isEnableEdit ? `rs-btn-ghost-edit` : `rs-btn-ghost-df`}
                size="sm"
                icon={
                  <Icon
                    icon={schema.isEnableEdit ? `edit` : `eye`}
                    className={
                      schema.isEnableEdit
                        ? `bt-gost-icon-none-radius-edit`
                        : `bt-gost-icon-none-radius`
                    }
                  />
                }
                style={{ width: '100%' }}
                onClick={(e) => {
                  onSelect(rowData, '2')
                }}
              >
                {schema.isEnableEdit ? `แก้ไขเงินคืน` : `แสดง`}
              </IconButton>
            </>
          ) : (
            <IconButton
              appearance="ghost"
              className={
                schema.isEnableEdit && rowData.borrowStatus != 3
                  ? `rs-btn-ghost-edit`
                  : `rs-btn-ghost-df`
              }
              size="sm"
              style={{ width: '100%' }}
              icon={
                <Icon
                  icon={schema.isEnableEdit && rowData.borrowStatus != 3 ? `edit` : `eye`}
                  className={
                    schema.isEnableEdit && rowData.borrowStatus != 3
                      ? 'bt-gost-icon-none-radius-edit'
                      : 'bt-gost-icon-none-radius'
                  }
                />
              }
              onClick={(e) => {
                onSelect(rowData, '1')
              }}
            >
              {schema.isEnableEdit && rowData.borrowStatus != 3 ? `แก้ไขเงินยืม` : `แสดง`}
            </IconButton>
          )}

          <IconButton
            appearance="ghost"
            className="rs-btn-ghost-info"
            size="sm"
            icon={<Icon icon="print" className="bt-gost-icon-none-radius-info" />}
            style={{ ...manageButtonStyle }}
            onClick={() => handleGetBorrowContratForm(rowData.id)}
          >
            สัญญายืมเงิน
          </IconButton>

          {rowData.borrowExpenseId && (
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-info"
              size="sm"
              icon={<Icon icon="print" className="bt-gost-icon-none-radius-info" />}
              style={{ ...manageButtonStyle }}
              onClick={() => handleGetExpenseVoucher(rowData.borrowExpenseId)}
            >
              ใบสำคัญจ่าย(ยืมเงิน)
            </IconButton>
          )}

          {rowData.borrowStatus == 2 && (
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-info"
              size="sm"
              icon={<Icon icon="print" className="bt-gost-icon-none-radius-info" />}
              style={{ ...manageButtonStyle }}
              onClick={() => handleGetBorrowRetrunForm(rowData.id)}
            >
              ใบใช้คืนเงินยืม
            </IconButton>
          )}

          {rowData.borrowStatus == 2 && (
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-info"
              size="sm"
              icon={<Icon icon="print" className="bt-gost-icon-none-radius-info" />}
              style={{ ...manageButtonStyle }}
              onClick={() => handleGetBorrowVoucher(rowData.id)}
            >
              ใบสําคัญรับเงินยืม
            </IconButton>
          )}

          {rowData.borrowStatus == 2 && (
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-info"
              size="sm"
              icon={<Icon icon="print" className="bt-gost-icon-none-radius-info" />}
              style={{ ...manageButtonStyle }}
              onClick={() => handleGetExpenseVoucher(rowData.accountingExpenseId)}
            >
              ใบสำคัญจ่าย(คืนเงิน)
            </IconButton>
          )}

          {rowData.borrowStatus == 2 && rowData.balanceAmount > 0 && (
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-info"
              size="sm"
              icon={<Icon icon="print" className="bt-gost-icon-none-radius-info" />}
              style={{ ...manageButtonStyle }}
              onClick={() => handleGetBorrowRecieptVoucher(rowData.id)}
            >
              ใบเสร็จรับเงินคืน
            </IconButton>
          )}
        </div>
      </Popover>
    )
  }

  const WithDropdown = ({ datas }) => {
    const triggerRef = React.createRef()
    function handleSelectMenu(eventKey, event) {
      console.log(eventKey)
      triggerRef.current.hide()
    }
    return (
      <Whisper
        placement="leftStart"
        trigger="click"
        triggerRef={triggerRef}
        speaker={<MenuPopover onSelected={handleSelectMenu} rowData={datas} />}
      >
        <IconButton
          appearance="ghost"
          className={`rs-btn-ghost-df`}
          size="sm"
          block
          icon={<Icon icon={`gear-circle`} className={'bt-gost-icon-none-radius'} />}
        >
          จัดการรายการ
        </IconButton>
      </Whisper>
    )
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel bordered header={'ค้นหา'} collapsible defaultExpanded>
        <div style={{ marginTop: -20, marginBottom: -20 }}>
          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.borrowType.label}
              <SelectPicker
                searchable={false}
                value={borrowType}
                data={schema.borrowType.options}
                block
                onChange={(value) => {
                  setBorrowType(value)
                }}
              />
            </Col>

            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.voucherNumber.label}
              <Input
                value={voucherNumber}
                onChange={(value) => {
                  setVoucherNumber(value)
                }}
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
          </Row>

          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.borrower.label}
              <SelectPicker
                searchable={false}
                value={borrower}
                data={schema.borrower.options}
                block
                onChange={(value) => {
                  setBorrower(value)
                }}
              />
            </Col>

            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.borrowDesc.label}
              <Input
                value={borrowDesc}
                onChange={(value) => {
                  setBorrowDesc(value)
                }}
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
          </Row>

          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.borrowStartDate.label}
              <DatePickerCustom
                {...props}
                placement="auto"
                value={borrowStartDate}
                onChange={(value) => {
                  setBorrowStartDate(value)
                }}
                disabledDate={(date) =>
                  borrowEndDate && moment(borrowEndDate).isBefore(date, new Date())
                }
              />
            </Col>

            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.borrowEndDate.label}
              <DatePickerCustom
                {...props}
                placement="auto"
                value={borrowEndDate}
                onChange={(value) => {
                  setBorrowEndDate(value)
                }}
                disabledDate={(date) =>
                  borrowStartDate && moment(borrowStartDate).isAfter(date, new Date())
                }
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
          </Row>

          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.returnStartDate.label}
              <DatePickerCustom
                {...props}
                placement="auto"
                value={returnStartDate}
                onChange={(value) => {
                  setReturnStartDate(value)
                }}
                disabledDate={(date) =>
                  returnEndDate && moment(returnEndDate).isBefore(date, new Date())
                }
              />
            </Col>

            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.returnEndDate.label}
              <DatePickerCustom
                {...props}
                placement="auto"
                value={returnEndDate}
                onChange={(value) => {
                  setReturnEndDate(value)
                }}
                disabledDate={(date) =>
                  returnStartDate && moment(returnStartDate).isAfter(date, new Date())
                }
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
          </Row>

          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              <SearchButton disabled={false} onClick={handleSearch}>
                ค้นหา
              </SearchButton>
              {`  `}
              <CancelButton disabled={false} onClick={handleCancel}>
                ยกเลิก
              </CancelButton>
            </Col>
          </Row>
        </div>
      </Panel>

      <div style={{ marginTop: 20 }}>
        <Row>
          {schema?.isEnableEdit && (
            <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <SaveButton
                icon="plus-square"
                disabled={false}
                onClick={() => {
                  onSelect(null, '1')
                }}
                style={{
                  marginRight: 10,
                }}
              >
                เพิ่มยืมเงินทดรองจ่าย
              </SaveButton>
              <CancelButton
                icon="minus-square"
                disabled={false}
                onClick={() => {
                  onSelect(null, '2')
                }}
                style={{
                  marginRight: 10,
                }}
              >
                คืนเงินทดรองจ่าย
              </CancelButton>
            </Col>
          )}
        </Row>
      </div>

      <div className="table-affix-header">
        <Table
          wordWrap
          minHeight={350}
          autoHeight
          loading={loading}
          data={tableData}
          style={{ marginTop: 10 }}
          headerHeight={fs < 16 ? 60 : fs <= 18 ? 75 : 80}
          rowClassName={(rowData) => (rowData && rowData.isSaveDraft ? 'saved-row' : '')}
          affixHeader
        >
          <Column width={90} align="center">
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>

          <Column width={190} align="center">
            <HeaderCell style={styleHeaderCell}>สถานะ</HeaderCell>
            <TagCell dataKey="borrowStatus" />
          </Column>

          <Column width={150} align="center">
            <HeaderCell>
              <div style={styleHeaderCell}>วันที่เอกสาร</div>
            </HeaderCell>
            <Cell dataKey="documentDate" />
          </Column>
          <Column width={150} align="center">
            <HeaderCell>
              <div style={styleHeaderCell}>เลขที่ใบสำคัญยืม</div>
            </HeaderCell>

            <Cell dataKey="borrowVoucherNumber" />
          </Column>
          <Column width={140}>
            <HeaderCell>
              <div style={styleHeaderCell}>จำนวนเงินยืม(บาท)</div>
            </HeaderCell>
            <Cell style={{ textAlign: 'right' }}>
              {(rowData) => {
                return budgetFormat(rowData.borrowAmount)
              }}
            </Cell>
          </Column>
          <Column width={140}>
            <HeaderCell>
              <div style={styleHeaderCell}>วันที่เริ่มกิจกรรม</div>
            </HeaderCell>
            <Cell dataKey="activityStartDate" />
          </Column>
          <Column width={140}>
            <HeaderCell>
              <div style={styleHeaderCell}>วันที่สิ้นสุดกิจกรรม</div>
            </HeaderCell>
            <Cell dataKey="activityEndDate" />
          </Column>
          <Column width={140}>
            <HeaderCell>
              <div style={styleHeaderCell}>วันที่ยืม</div>
            </HeaderCell>
            <Cell dataKey="borrowDate" />
          </Column>
          <Column width={150} align="center">
            <HeaderCell>
              <div style={styleHeaderCell}>วันที่ครบกำหนดคืน</div>
            </HeaderCell>
            <Cell dataKey="estimateReturnDate" />
          </Column>
          <Column width={140} align="center">
            <HeaderCell>
              <div style={styleHeaderCell}>จำนวนวันที่เกิน</div>
            </HeaderCell>
            <Cell>
              {(rowData) => {
                if (rowData.overEstimateReturnDate > 0) {
                  return <b style={{ color: '#fb8a81' }}>{rowData.overEstimateReturnDate}</b>
                }
              }}
            </Cell>
          </Column>
          <Column width={300}>
            <HeaderCell>
              <div style={styleHeaderCell}>วัตถุประสงค์การยืม</div>
            </HeaderCell>
            <Cell dataKey="description" />
          </Column>
          <Column width={180}>
            <HeaderCell>
              <div style={styleHeaderCell}>ผู้ยืมเงินทดรองจ่าย</div>
            </HeaderCell>
            <Cell dataKey="borrower" />
          </Column>

          <Column width={140} align="center">
            <HeaderCell>
              <div style={styleHeaderCell}>เลขที่ใบสำคัญคืน</div>
            </HeaderCell>
            <Cell dataKey="returnVoucherNumber" />
          </Column>
          <Column width={140} align="center">
            <HeaderCell>
              <div style={styleHeaderCell}>วันที่คืน</div>
            </HeaderCell>
            <Cell dataKey="returnDate" />
          </Column>
          <Column width={150} align="right">
            <HeaderCell>
              <div style={styleHeaderCell}>จำนวนเงินคืน</div>
            </HeaderCell>
            <Cell>
              {(rowData) => {
                return budgetFormat(rowData.returnAmount || 0)
              }}
            </Cell>
          </Column>
          <Column width={150}>
            <HeaderCell>
              <div style={styleHeaderCell}>จำนวนเงินรับคืน/เบิกเพิ่ม</div>
            </HeaderCell>
            <Cell style={{ textAlign: 'right' }}>
              {(rowData) => {
                return budgetFormat(rowData.balanceAmount || 0)
              }}
            </Cell>
          </Column>

          <Column width={150} align="center">
            <HeaderCell>
              <div style={styleHeaderCell}>วันที่บันทึกรายการ</div>
            </HeaderCell>
            <Cell dataKey="createDate" />
          </Column>

          <Column width={fs < 16 ? 150 : fs < 18 ? 160 : 180} align="center" fixed="right">
            <HeaderCell>
              <div style={styleHeaderCell}>จัดการรายการ</div>
            </HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <>
                    <WithDropdown datas={rowData} />

                    {/* <ButtonGroup> */}
                    {/* {rowData.borrowStatus != 3 && rowData.borrowStatus == 2 && (
                    <IconButton
                      appearance="ghost"
                      className={`rs-btn-ghost-df`}
                      size="sm"
                      style={{ width: '100%' }}
                      icon={<Icon icon={`eye`} className={'bt-gost-icon-none-radius'} />}
                      onClick={(e) => {
                        onSelect(rowData, '1')
                      }}
                    >
                      แสดงเงินยืม {rowData.borrowStatus}
                    </IconButton>
                  )} */}

                    {/* {rowData.borrowStatus == 2 ? (
                    <>
                      <IconButton
                        appearance="ghost"
                        className={schema.isEnableEdit ? `rs-btn-ghost-edit` : `rs-btn-ghost-df`}
                        size="sm"
                        icon={
                          <Icon
                            icon={schema.isEnableEdit ? `edit` : `eye`}
                            className={
                              schema.isEnableEdit
                                ? `bt-gost-icon-none-radius-edit`
                                : `bt-gost-icon-none-radius`
                            }
                          />
                        }
                        style={{ width: '100%' }}
                        onClick={(e) => {
                          onSelect(rowData, '2')
                        }}
                      >
                        {schema.isEnableEdit ? `แก้ไขเงินคืน` : `แสดง`}
                      </IconButton>
                    </>
                  ) : (
                    <IconButton
                      appearance="ghost"
                      className={
                        schema.isEnableEdit && rowData.borrowStatus != 3
                          ? `rs-btn-ghost-edit`
                          : `rs-btn-ghost-df`
                      }
                      size="sm"
                      style={{ width: '100%' }}
                      icon={
                        <Icon
                          icon={schema.isEnableEdit && rowData.borrowStatus != 3 ? `edit` : `eye`}
                          className={
                            schema.isEnableEdit && rowData.borrowStatus != 3
                              ? 'bt-gost-icon-none-radius-edit'
                              : 'bt-gost-icon-none-radius'
                          }
                        />
                      }
                      onClick={(e) => {
                        onSelect(rowData, '1')
                      }}
                    >
                      {schema.isEnableEdit && rowData.borrowStatus != 3 ? `แก้ไขเงินยืม` : `แสดง`}
                    </IconButton>
                  )} */}

                    {/* <IconButton
                    appearance="ghost"
                    className="rs-btn-ghost-info"
                    size="sm"
                    icon={<Icon icon="print" className="bt-gost-icon-none-radius-info" />}
                    style={{ ...manageButtonStyle }}
                    onClick={() => handleGetBorrowContratForm(rowData.id)}
                  >
                    สัญญายืมเงิน
                  </IconButton> */}

                    {/* {rowData.borrowExpenseId && (
                    <IconButton
                      appearance="ghost"
                      className="rs-btn-ghost-info"
                      size="sm"
                      icon={<Icon icon="print" className="bt-gost-icon-none-radius-info" />}
                      style={{ ...manageButtonStyle }}
                      onClick={() => handleGetExpenseVoucher(rowData.borrowExpenseId)}
                    >
                      ใบสำคัญจ่าย(ยืมเงิน)
                    </IconButton>
                  )} */}

                    {/* {rowData.borrowStatus == 2 && (
                    <IconButton
                      appearance="ghost"
                      className="rs-btn-ghost-info"
                      size="sm"
                      icon={<Icon icon="print" className="bt-gost-icon-none-radius-info" />}
                      style={{ ...manageButtonStyle }}
                      onClick={() => handleGetBorrowRetrunForm(rowData.id)}
                    >
                      ใบใช้คืนเงินยืม
                    </IconButton>
                  )} */}

                    {/* {rowData.borrowStatus == 2 && (
                    <IconButton
                      appearance="ghost"
                      className="rs-btn-ghost-info"
                      size="sm"
                      icon={<Icon icon="print" className="bt-gost-icon-none-radius-info" />}
                      style={{ ...manageButtonStyle }}
                      onClick={() => handleGetBorrowVoucher(rowData.id)}
                    >
                      ใบสําคัญรับเงินยืม
                    </IconButton>
                  )} */}

                    {/* {rowData.borrowStatus == 2 && (
                    <IconButton
                      appearance="ghost"
                      className="rs-btn-ghost-info"
                      size="sm"
                      icon={<Icon icon="print" className="bt-gost-icon-none-radius-info" />}
                      style={{ ...manageButtonStyle }}
                      onClick={() => handleGetExpenseVoucher(rowData.accountingExpenseId)}
                    >
                      ใบสำคัญจ่าย(คืนเงิน)
                    </IconButton>
                  )} */}

                    {/* {rowData.borrowStatus == 2 && rowData.balanceAmount > 0 && (
                    <IconButton
                      appearance="ghost"
                      className="rs-btn-ghost-info"
                      size="sm"
                      icon={<Icon icon="print" className="bt-gost-icon-none-radius-info" />}
                      style={{ ...manageButtonStyle }}
                      onClick={() => handleGetBorrowRecieptVoucher(rowData.id)}
                    >
                      ใบเสร็จรับเงินคืน
                    </IconButton>
                  )} */}
                  </>
                )
              }}
            </Cell>
          </Column>
        </Table>
      </div>
    </>
  )
}
